/**
 * Nsection B11 Service
 * B.11.活動情景 API 服務
 */

import axios from '../api/axios';

const BASE_URL = '/api/nsection-b11';

export interface FormulaParameter {
  symbol: string;
  para_type?: number | null;
  scenarios: string;
  unit: string;
  annual_value: number | null;
}

export interface FormulaEntry {
  id: string;
  equation_note: string;
  equation: { latex: string };
  parameters: FormulaParameter[];
  calculation_result: { value: number | null; unit: string };
}

export interface NsectionB11Detail {
  id: number;
  organization_id: number;
  proposal_id: number;
  activity_calculate: FormulaEntry[] | null;
  activity_description: string | null;
  nsection_b11_pct: number;
  edit_by: number;
  created_at: string;
  updated_at: string | null;
}

export interface NsectionB11Update {
  activity_calculate?: FormulaEntry[];
  activity_description?: string;
}

const nsectionB11Service = {
  getByProposal: async (proposalId: number): Promise<NsectionB11Detail | null> => {
    const response = await axios.get(`${BASE_URL}/by-proposal/${proposalId}`);
    return response.data;
  },
  update: async (proposalId: number, data: NsectionB11Update): Promise<NsectionB11Detail> => {
    const response = await axios.put(`${BASE_URL}/${proposalId}`, data);
    return response.data;
  },
};

export default nsectionB11Service;
